import form from './form';
import generate from './generate';
import filter from './filter';

export default {
  form,
  generate,
  filter,
};
